import React from 'react';

import Icon from 'editor/src/component/Icon/index';

interface Props {
  className?: string;
}

// Water drop with its lower half filled, the common "opacity" symbol.
function IconOpacity({ className }: Props) {
  return (
    <Icon className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L7.05 7.95A7 7 0 1 0 16.95 7.95L12 3Z" stroke="#212121" strokeWidth="2" strokeLinejoin="round" />
        <path d="M5 12.9A7 7 0 0 0 19 12.9H5Z" fill="#212121" style={{ strokeWidth: 0 }} />
      </svg>
    </Icon>
  );
}

export default React.memo(IconOpacity);
